import { Button } from "@deligoo/ui"
import clsx from "clsx"
import { memo, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"

import { useAppSelector } from "@/App"
import { Main } from "@/components/AppLayout"
import { Status } from "@/components/Status"
import { Table } from "@/components/Table"
import { OrderContextMenu, OrderContextMenuAction, OrderItemContext } from "@/modules/OrderContextMenu"
import { selectCount } from "@/store"
import { selectFilteredOrders } from "@/store/orders"
import { selectCurrentTeamStats } from "@/store/teamsStats"
import { Order } from "@/types"

import cls from "./OrdersListView.module.scss"
import { Filters } from "./partials/Filters"
import { OrdersTable } from "./partials/OrdersTable"

export const OrdersListView = memo(() => {
  const isTeamSelected = useAppSelector((state) => Boolean(state.teams.current))

  const currentTeamStats = useAppSelector(selectCurrentTeamStats)

  const [showBufferTable, setShowBufferTable] = useState(false)
  const [filters, setFilters] = useState<Array<(order: Order) => boolean>>([])
  const [orderContextMenuAction, setOrderContextMenuAction] = useState<OrderContextMenuAction | null>(null)

  const ordersInBufferFilters = useMemo(() => [(order: Order) => order.is_buffered, ...filters], [filters])
  const ordersFilters = useMemo(() => [(order: Order) => !order.is_buffered, ...filters], [filters])

  const bufferOrdersCount = useAppSelector(selectCount(selectFilteredOrders(...ordersInBufferFilters)))

  const { t } = useTranslation()

  if (!isTeamSelected || !currentTeamStats) return <Status type="no_team" title={t("list_view")} fullHeight />

  return (
    <Main page pageContrast>
      <OrderItemContext.Provider value={{ orderContextMenuAction, setOrderContextMenuAction }}>
        <Filters setFilters={setFilters} />

        <Table.Card className={cls.bufferTable}>
          <button
            className={clsx(cls.bufferButton, showBufferTable && cls.active)}
            onClick={() => setShowBufferTable((currentValue) => !currentValue)}
          >
            <span className={cls.heading}>
              {t("orders:orders", {
                count: bufferOrdersCount,
              })}{" "}
              w buforze ({currentTeamStats.dynamic_buffer_current_value} min)
            </span>

            <span className={cls.heading}>
              Rzeczywisty czas buforowania ({currentTeamStats?.dynamic_buffer_real_value} min)
            </span>

            <Button
              as="div"
              size="small"
              color="muted"
              variation="outlined"
              iconProps={{ name: "chevron-tiny-down" }}
              className={cls.icon}
            />
          </button>

          {showBufferTable && <OrdersTable filters={ordersInBufferFilters} />}
        </Table.Card>

        <Table.Card>
          <OrdersTable filters={ordersFilters} virtualized />
        </Table.Card>

        <OrderContextMenu />
      </OrderItemContext.Provider>
    </Main>
  )
})
